import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import KeywordSuggestionModal from '@/components/container/modal/article/KeywordSuggestionModal'

interface KeywordSuggestionModalState {
  siteId: number
  keyword: string
  siteUrl?: string | null
  onApply(keyword: string): void
}

const defaultValue: KeywordSuggestionModalState = {
  siteId: 0,
  keyword: '',
  onApply: () => undefined
}

export const KeywordSuggestionModalContext =
  createModalContext<KeywordSuggestionModalState>(defaultValue)

const KeywordSuggestionModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<KeywordSuggestionModalState>(defaultValue)
  return (
    <KeywordSuggestionModalContext.Provider value={state}>
      {children}
      <KeywordSuggestionModal />
    </KeywordSuggestionModalContext.Provider>
  )
}

export default KeywordSuggestionModalProvider
